import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=13d57abb&"
import script from "./ShareLinks.vue?vue&type=script&lang=ts&"
export * from "./ShareLinks.vue?vue&type=script&lang=ts&"
import style0 from "./ShareLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports